"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactSvg = _interopRequireDefault(require("react-svg"));

var Robot =
/*#__PURE__*/
function (_PureComponent) {
  (0, _inherits2["default"])(Robot, _PureComponent);

  function Robot() {
    (0, _classCallCheck2["default"])(this, Robot);
    return (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(Robot).apply(this, arguments));
  }

  (0, _createClass2["default"])(Robot, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          bsStyle = _this$props.bsStyle,
          size = _this$props.size,
          alternate = _this$props.alternate;
      return _react["default"].createElement("div", {
        className: "robot robot-".concat(size)
      }, _react["default"].createElement("div", {
        className: "robot-bg"
      }, _react["default"].createElement(_reactSvg["default"], {
        path: "https://static.ux.cimpress.io/assets/images/bg_diamond-".concat(bsStyle, ".svg")
      })), _react["default"].createElement("div", {
        className: "robot-figure"
      }, _react["default"].createElement(_reactSvg["default"], {
        path: "https://static.ux.cimpress.io/assets/images/robot-".concat(bsStyle).concat(alternate ? '-2' : '', ".svg")
      })));
    }
  }]);
  return Robot;
}(_react.PureComponent);

exports["default"] = Robot;
Robot.propTypes = {
  bsStyle: _propTypes["default"].oneOf(['success', 'info', 'warning', 'danger']),
  size: _propTypes["default"].oneOf(['sm', 'lg']),
  alternate: _propTypes["default"].bool
};
Robot.defaultProps = {
  bsStyle: 'success',
  size: 'sm'
};